"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatToDateTimeInputValue = exports.formatToDateInputValue = exports.getMonthStartEnd = exports.formatYearMonth = exports.formatDate = exports.getDayOfYear = exports.getDateFromDayOfYear = exports.ONE_DAY_IN_MS = exports.sortDates = exports.add24h = exports.getUnixTimeStamp = void 0;
const getUnixTimeStamp = (date) => {
    const time = date.getTime();
    const timeStamp = Math.round(time / 1000);
    return timeStamp;
};
exports.getUnixTimeStamp = getUnixTimeStamp;
const SECOND = 1000;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;
const add24h = (date) => {
    const newTime = date.getTime() + DAY;
    return new Date(newTime);
};
exports.add24h = add24h;
const sortDates = (dateA, dateB) => {
    return dateA.getTime() - dateB.getTime();
};
exports.sortDates = sortDates;
exports.ONE_DAY_IN_MS = 1000 * 60 * 60 * 24;
const getDateFromDayOfYear = (day, year) => {
    const start = new Date(year, 0, 0).getTime();
    return new Date(start + day * exports.ONE_DAY_IN_MS);
};
exports.getDateFromDayOfYear = getDateFromDayOfYear;
const getDayOfYear = (date) => {
    const start = new Date(date.getFullYear(), 0, 0).getTime();
    return Math.floor((date.getTime() - start) / exports.ONE_DAY_IN_MS);
};
exports.getDayOfYear = getDayOfYear;
const DATE_LOCALE = "en-US";
const formatDate = (date, showYear) => {
    if (showYear) {
        return date.toLocaleString(DATE_LOCALE, {
            month: "short",
            day: "numeric",
            year: "numeric",
        });
    }
    return date.toLocaleDateString(DATE_LOCALE, {
        month: "short",
        day: "numeric",
    });
};
exports.formatDate = formatDate;
const formatYearMonth = (date) => date.toLocaleDateString("en-US", { month: "long", year: "numeric" });
exports.formatYearMonth = formatYearMonth;
const getMonthStartEnd = (date) => {
    const start = new Date(date.getFullYear(), date.getMonth(), 1);
    const end = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999);
    return { start, end };
};
exports.getMonthStartEnd = getMonthStartEnd;
// yyyy-MM-dd <-- W3C format for DateTimeInput
const formatToDateInputValue = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};
exports.formatToDateInputValue = formatToDateInputValue;
// yyyy-MM-ddThh:mm:ss <-- W3C format for DateTimeInput (UTC for now)
const formatToDateTimeInputValue = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const h = String(date.getHours()).padStart(2, "0");
    const m = String(date.getMinutes()).padStart(2, "0");
    const s = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day}T${h}:${m}:${s}`;
};
exports.formatToDateTimeInputValue = formatToDateTimeInputValue;
